<template>
    <div>
        <el-button type="primary" @click="showDialog = true">{{title}}</el-button>
        <el-dialog :title="'选择可派送区域'" :visible.sync="showDialog" width="40%" @close="closeDialog">
            <div>
                <div style="width: 100%;text-align: right; margin-bottom: 15px;">
                    <el-checkbox v-model="select" @change="selectAll('')">全选</el-checkbox>
                    <span style="margin-left: 8px;cursor: pointer;" @click="selectAll('clear')">清空</span>
                </div>
                
                <!-- 两列表格样式的省市选择 -->
                <div style="display: flex; height: 400px; border: 1px solid #e4e7ed;">
                    <!-- 省份列表 -->
                    <div style="width: 200px; overflow-y: auto; border-right: 1px solid #e4e7ed;">
                        <div 
                            v-for="(province, index) in areaTreeDate" 
                            :key="province.id"
                            style="padding: 10px 15px; border-bottom: 1px solid #e4e7ed; cursor: pointer;"
                            :class="{'hover-bg': true}"
                            @click="toggleProvince(index)"
                        >
                            <div style="display: flex; justify-content: space-between; align-items: center;">
                                <el-checkbox v-model="province.checked" @change="(event) => checked(event, index)" @click.stop >
                                    {{ province.areaName }}
                                </el-checkbox>
                                <span style="color: #909399; display: flex; align-items: center;">
                                    <span v-if="province.loading" style="margin-right: 5px;">加载中...</span>
                                    <el-icon v-else-if="activeProvinceIndex === index"><ArrowDown /></el-icon>
                                    <el-icon v-else><ArrowRight /></el-icon>
                                </span>
                            </div>
                        </div>
                    </div>
                    
                    <!-- 城市列表 -->
                    <div style="flex: 1; overflow-y: auto;">
                        <!-- 显示当前选中省份的城市 -->
                        <div v-if="activeProvinceIndex !== -1">
                            <div v-if="areaTreeDate[activeProvinceIndex]" :key="areaTreeDate[activeProvinceIndex].id">
                                <div v-for="(city, cityIndex) in areaTreeDate[activeProvinceIndex].children" 
                                    :key="city.id" style="padding: 10px 15px; border-bottom: 1px solid #e4e7ed;">
                                    <el-checkbox v-model="city.checked" @change="checkedChildren($event, activeProvinceIndex, cityIndex)" @click.stop >
                                        {{ city.areaName }}
                                    </el-checkbox>
                                </div>
                                
                                <!-- 如果正在加载且没有城市数据，显示加载提示 -->
                                <div 
                                    v-if="areaTreeDate[activeProvinceIndex].loading && areaTreeDate[activeProvinceIndex].children.length === 0"
                                    style="padding: 20px; text-align: center; color: #909399;"
                                >
                                    <span>加载中...</span>
                                </div>
                                
                                <!-- 如果没有城市数据，显示提示 -->
                                <div 
                                    v-if="!areaTreeDate[activeProvinceIndex].loading && areaTreeDate[activeProvinceIndex].children.length === 0 && areaTreeDate[activeProvinceIndex].loaded"
                                    style="padding: 20px; text-align: center; color: #909399;"
                                >
                                    暂无城市数据
                                </div>
                            </div>
                        </div>
                        
                        <!-- 未选择省份时的提示 -->
                        <div 
                            v-else
                            style="padding: 50px; text-align: center; color: #909399;"
                        >
                            请选择一个省份查看城市列表
                        </div>
                    </div>
                </div>
                
                <div slot="footer" class="flex justify-end" style="margin-top: 15px;">
                    <el-button @click="closeDialog">取消</el-button>
                    <el-button type="primary" @click="submitForm">确定</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { get, post} from '@/utils/request.js';
import { ArrowDown, ArrowRight } from '@v2icons/tabler';

export default {
    components: {
        ArrowDown,
        ArrowRight
    },
    data() {
        return {
            showDialog: false,
            areaTreeDate: [], //省数据
            cityTreeDate: [], //市数据
            select: false,
            activeProvinceIndex: -1 // 当前选中的省份索引
        }
    },
    props:{
        title:{
            type:String,
            default:()=>{
                return '添加区域'
            }
        }
    },
    created() {
        // 组件创建时不立即加载数据
    },
    watch: {
        // 监听对话框显示状态，当显示时加载数据
        showDialog(newVal) {
            if (newVal) {
                this.getTreeData();
            }
        }
    },
    methods: {
        // 获取地理位置 - 只加载省份数据
        async getTreeData() {
            try {
                // 先清空现有数据
                this.areaTreeDate = [];
                
                // 调用省份接口获取省份数据
                const provinceRes = await get('/mpp/areaArea/provinceSelect');
                
                if (provinceRes.success) {
                    const provinces = provinceRes.mppAreaProvinceList || [];
                    console.log("省份数据",provinces)
                    provinces.forEach(province => {
                        this.areaTreeDate.push({
                            id: province.id,
                            areaName: province.name,
                            checked: false,  // 是否选中
                            children: [],   // 子城市数据
                            acount: 0,      // 已选择的城市数量
                            count: 0,       // 总城市数量
                            expanded: false, // 添加展开状态
                            loading: false, // 添加加载状态
                            loaded: false // 添加是否已加载标记
                        });
                    });
                }
            } catch (error) {
                console.error('获取省份数据失败:', error);
                this.$message.error('获取地区数据失败，请稍后重试');
            }
        },
        
        // 加载指定省份的城市数据
        async loadCityData(index) {
            const province = this.areaTreeDate[index];
            if (!province) return; // 添加空值检查
            
            console.log("province", province)
            try {
                // 设置加载状态
                province.loading = true;

                // const mppAreaCity = {
                //     pid: province.id
                // }
                // 调用城市接口
                const cityRes = await get('/mpp/areaArea/citySelect', { pid: province.id});
                
                if (cityRes.success) {
                    const cities = cityRes.mppAreaCityList || [];
                    console.log("城市数据", cities)
                    // 清空现有城市数据
                    province.children = [];
                    province.count = cities.length;
                    // 只有当省份未被勾选时才重置已选择的城市数量
                    if (!province.checked) {
                        province.acount = 0;
                    }
                    
                    // 添加城市数据
                    cities.forEach(city => {
                        province.children.push({
                            id: city.id,
                            areaName: city.name ,
                            checked: province.checked // 如果省份已被勾选，城市也自动勾选
                        });
                    });
                    
                    // 如果省份已被勾选，更新已选择的城市数量
                    if (province.checked) {
                        province.acount = cities.length;
                    }
                    
                    // 标记为已加载
                    province.loaded = true;
                }
            } catch (error) {
                console.error(`获取省份 ${province?.areaName} 的城市数据失败:`, error);
                this.$message.error(`获取${province?.areaName || '省份'}的城市数据失败，请稍后重试`);
            } finally {
                // 取消加载状态
                province.loading = false;
            }
        },
        
        // 切换省份的展开/折叠状态
        async toggleProvince(index) {
            const province = this.areaTreeDate[index];
            if (!province) return; // 添加空值检查
            
            // 如果未加载过城市数据，则加载
            if(!province.loaded){
                await this.loadCityData(index);
            }
            
            // 更新当前选中的省份索引
            this.activeProvinceIndex = this.activeProvinceIndex === index ? -1 : index;
        },
        // 单一省市勾选
        checked(event,key,sign=""){
            console.log("key",key)
            if(sign != "select"){
                // 勾选省份时自动设置为当前活跃省份
                if (event && this.activeProvinceIndex !== key) {
                    this.activeProvinceIndex = key;
                    // 如果城市数据未加载，自动加载
                    if (!this.areaTreeDate[key].loaded) {
                        this.loadCityData(key);
                    }
                }
                
                this.areaTreeDate[key].acount = event ? this.areaTreeDate[key].count : 0
                for(let iterator of this.areaTreeDate[key].children) {
                    iterator.checked = event
                }
            }
            let bool = true
            for (const iterator of this.areaTreeDate) {
                if(iterator.checked == false){
                    bool = false
                    break
                }
            }
            this.select = bool
        },
        //
        checkedChildren(event, provinceIndex, cityIndex){
            if(event){  
                this.areaTreeDate[provinceIndex].acount++
            }else{
                this.areaTreeDate[provinceIndex].acount--
            }
            
            // 更新省份的勾选状态：只有当所有城市都被选中时，才勾选省份方框
            if(this.areaTreeDate[provinceIndex].acount === this.areaTreeDate[provinceIndex].count){
                this.areaTreeDate[provinceIndex].checked = true
                this.checked(true, provinceIndex, "select")
            }else{
                // 部分选择城市时，不勾选省份方框
                this.areaTreeDate[provinceIndex].checked = false
            }
        },
        // 全选全不选/清空
        selectAll(sign){
            if(sign == "clear"){
                this.select = false
            }
            this.areaTreeDate.forEach((element) => {
                element.checked = this.select
                element.acount = this.select ? element.count : 0
                for (let iterator of element.children) {
                    iterator.checked = this.select
                }
            })
        },
        // 确定
        submitForm(){
            // 检查是否有选中的城市或省份
            let hasChecked = this.areaTreeDate.some(province => 
                province.checked || province.children.some(city => city.checked)
            );
            
            if (!hasChecked) {
                return;
            }
            
            let data = [];  // 存储选中的城市数据
            let selectedNames = []; // 存储选中的城市名称
            
            this.areaTreeDate.forEach(province => {
                let selectedCities = province.children.filter(child => child.checked);
                
                if (province.checked && province.acount === province.count) {
                    // 全选城市，只返回省份
                    let provinceData = {
                        name: province.areaName,
                        cityId: province.id,
                        children: selectedCities.map(child => ({
                            name: child.areaName,
                            cityId: child.id
                        }))
                    };
                    data.push(provinceData);
                    selectedNames.push(province.areaName);
                } else if (selectedCities.length > 0) {
                    // 部分选择，返回省份+城市
                    let provinceData = {
                        name: province.areaName,
                        cityId: province.id,
                        children: selectedCities.map(child => ({
                            name: child.areaName,
                            cityId: child.id
                        }))
                    };
                    data.push(provinceData);
                    
                    // 拼接省份名称+城市名称，多个城市用逗号隔开
                    let cityNames = selectedCities.map(city => city.areaName).join(',');
                    selectedNames.push(`${province.areaName}-${cityNames}`);
                }
            });
            
            let str = selectedNames.join(";");
            this.showDialog = false;
            this.$emit("address", data, str);
            this.selectAll('clear');
            // let bool = false
            // for (const iterator of this.areaTreeDate) {
            //     if(iterator.checked){
            //         bool = true
            //         break
            //     }
            // }
            // if(!bool){
            //     return
            // }
            // let arr = []
            // let arr1 = []
            // this.areaTreeDate.forEach(element => {
            //     let obj = {}
            //     if(element.checked){
            //         obj.name = element.areaName
            //         obj.cityId = element.id
            //         arr1.push(element.areaName)
            //         bool = true
            //     }
            //     obj.children = []
            //     for (const iterator of element.children) {
            //         if(iterator.checked){
            //             obj.children.push({
            //                 name:iterator.areaName,
            //                 cityId:iterator.id
            //             })
            //         }
            //     }
            //     if(obj.children.length == 0){
            //         delete obj.children
            //     }
            //     if(obj.name != undefined){
            //         arr.push(obj)
            //     }
            // });
            // let str = arr1.join(";")
            // this.showDialog = false
            // this.$emit("address",arr,str)
            // this.selectAll('clear')
        },
        closeDialog(){
            this.showDialog = false
            this.selectAll('clear')
        }
    },
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  button{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.hover-bg:hover {
  background-color: #f5f7fa;
}
</style>